import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { id } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_SPONSORSHIP_DELETE, {
      pathParams: { id },
    })
  },
  method: 'DELETE',
  format() {
    return {}
  },
  parse(raw = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to delete sponsorship',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Sponsorisation supprimée',
      data: raw.data,
    }
  },
}
